import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../shared/utils/apiConfig';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaPlus, FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { AiOutlineProduct } from 'react-icons/ai';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';
import {
  fetchProducts,
  deleteProducts,
  clearState,
} from '../../../redux/Slices/ProductsSlice';
import { useTitle } from '../../../context/TitleContext';
import ConfirmModal from '../../../shared/components/ConfirmModal';
import EnhancedPagination from '../../../shared/components/EnhancedPagination';
import axios from 'axios';

const Products = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setTitle } = useTitle();
  const [currentPage, setCurrentPage] = useState(1);
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, data: null });

  const { products, meta, isLoading, error, success } = useSelector(
    (state) => state.products
  );

 

  useEffect(() => {
    setTitle("المنتجات");
  }, [setTitle]);
  useEffect(() => {
    dispatch(clearState());
    dispatch(fetchProducts(currentPage));
  }, [dispatch, currentPage]);
  useEffect(() => {
    if (success) {
      showSuccessToast("تم الحذف بنجاح");
      dispatch(clearState());
      dispatch(fetchProducts(currentPage));
    }
    if (error) {
      const isOffline = typeof navigator !== 'undefined' && navigator.onLine === false;
      const message = isOffline
        ? "لا يوجد اتصال بالإنترنت. تحقق من الشبكة وحاول مرة أخرى"
        : (typeof error === 'string' ? error : (error?.message || "حدث خطأ غير متوقع"));
      showErrorToast(message);
      dispatch(clearState());
    }
  }, [success, error, dispatch, currentPage]);
  const [localProducts, setLocalProducts] = useState([]);

  useEffect(() => {
    if (products) {
      
      setLocalProducts(products);
    }
  }, [products]);


  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const toggleStatus = async (productId) => {
    try {
      const user = JSON.parse(sessionStorage.getItem("storekhadamat"));
      const token = user?.token;

      await apiPost('/products/store_toggle_product_status', { product_id: productId });

      // update status locally (no Redux needed)
      setLocalProducts((prev) => ({
        ...prev,
        result: Array.isArray(prev.result) ? prev.result.map((p) =>
          p.id === productId ? { ...p, status: !p.status } : p
        ) : prev.result,
      }));

      showSuccessToast("تم تغيير الحالة");
      dispatch(fetchProducts());
    } catch (error) {
      showErrorToast("فشل تغيير الحالة");
    }
  };

  const handlePageChange = (page) => {
    if (isLoading) return;
    if (page === currentPage) return;
    setCurrentPage(page);
  };

  const handleDelete = (id) => {
    setConfirmModal({
      isOpen: true,
      data: id,
      message: 'هل تريد حذف هذا المنتج؟',
      title: 'تأكيد الحذف'
    });
  };

  const executeDelete = () => {
    dispatch(deleteProducts(confirmModal.data));
  };

  const renderPagination = () => {
    const paginationData = meta || localProducts?.result?.pagination;
    if (!paginationData) return null;

    const { current_page, pages_count } = paginationData;
    const totalItems = paginationData.total || 0;
    const itemsPerPage = paginationData.per_page || 10;

    return (
      <div className="card-footer w-100 bg-light py-2 px-2">
        <div className="row align-items-center g-0">
          <div className="col-md-6 px-2">
            <div className="d-flex align-items-center gap-1 flex-wrap">
              <span className="text-muted">الانتقال إلى الصفحة</span>
              <div className="input-group" style={{ width: 'auto' }}>
                <span className="input-group-text" style={{ fontSize: '12px', color: '#6c757d', fontWeight: 'bold' }}>
                  #
                </span>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={currentPage}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (!isNaN(value) && value > 0) {
                      if (value <= pages_count) {
                        handlePageChange(value);
                      }
                    }
                  }}
                  min="1"
                  max={pages_count}
                  style={{ width: '60px' }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 px-2">
            <div className="d-flex justify-content-end gap-1 flex-wrap">
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handlePageChange(1)}
                disabled={currentPage <= 1}
              >
                الأولى
              </button>
              <button 
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage <= 1}
              >
                السابقة
              </button>
              <span className="d-flex align-items-center px-3">
                صفحة {current_page || currentPage} من {pages_count || 1}
              </span>
              <button 
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= (pages_count || 1)}
              >
                التالية
              </button>
              <button 
                className="btn btn-outline-secondary btn-sm"
                onClick={() => handlePageChange(pages_count || 1)}
                disabled={currentPage >= (pages_count || 1)}
              >
                الأخيرة
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (isLoading && (!Array.isArray(products?.result) || products.result.length === 0)) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">جاري التحميل...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center">
              <AiOutlineProduct
                className="mx-2 "
                style={{ fontSize: "1.5rem", color: "var(--main-color)" }}
              />
              <h4 style={{ fontSize: "1.1rem", margin: 0 }}>المنتجات</h4>
            </div>
            <motion.button
              className="btn text-white d-flex align-items-center"
              onClick={() => navigate("/add-product")}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{ background: "var(--main-color)" }}
            >
              <FaPlus className="mx-2" />
              إضافة منتج جديد
            </motion.button>
          </div>

          <div className="card">
            <div className="card-body">
              {!Array.isArray(localProducts?.result?.data) || localProducts.result.data.length === 0 ? (
                <div className="text-center py-5">
                  <AiOutlineProduct size={48} className="text-muted mb-3" />
                  <h5 className="text-muted">لا يوجد منتجات</h5>
                  <p className="text-muted">ابدأ بإضافة منتج جديد</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="table-light">
                        <tr>
                          <th style={{ textAlign: "center" }}>#</th>
                          <th style={{ textAlign: "center" }}>الاسم</th>
                          <th style={{ textAlign: "center" }}>الوصف</th>
                          <th style={{ textAlign: "center" }}>صورة</th>
                          <th style={{ textAlign: "center" }}>الحالة</th>
                          <th style={{ textAlign: "center" }}>الإجراءات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(localProducts?.result?.data) ? localProducts.result.data.map((product, index) => (
                          <tr key={product.id}>
                            <td style={{ textAlign: "center" }}>
                              {localProducts?.result?.pagination
                                ? (localProducts.result.pagination.current_page - 1) * localProducts.result.pagination.per_page +
                                  index +
                                  1
                                : index + 1}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {product.name}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {product.description}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <img
                                src={product?.first_image_url || "/user.webp"}
                                alt="--"
                                className="mx-auto border"
                                onError={(e) => (e.target.src = "/user.webp")}
                                style={{
                                  height: "50px",
                                  width: "50px",
                                  objectFit: "cover",
                                  borderRadius: "50%",
                                }}
                              />
                            </td>
                            {/* <td style={{ textAlign: "center" }}>
                                <span style={{fontSize:"11px"}} className={`${product.status === true?"bg-success":"bg-primary"} text-white rounded-4 py-1 px-3 text-sm`}>
                                {product.status === true?"مفعل":"غير مفعل"}
                                </span>
                            </td> */}
                            <td style={{ textAlign: "center" }}>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                {/* Switch */}
                                <div className="form-check form-switch m-0">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={`product-${product.id}`}
                                    checked={!!product.status}
                                    onChange={() => toggleStatus(product.id)}
                                  />
                                </div>

                                {/* Badge */}
                                <span
                                  className={`px-2 py-1 rounded-4 text-white`}
                                  style={{
                                    fontSize: "11px",
                                    backgroundColor: product.status
                                      ? "#198754"
                                      : "#0d6efd",
                                    minWidth: "60px",
                                    display: "inline-block",
                                    textAlign: "center",
                                  }}
                                >
                                  {product.status ? "مفعل" : "غير مفعل"}
                                </span>
                              </div>
                            </td>

                            <td style={{ textAlign: "center" }}>
                              <div
                                className="d-flex gap-2"
                                style={{ justifyContent: "center" }}
                              >
                                <motion.button
                                  className="btn btn-sm btn-outline-primary"
                                  style={{ fontSize: "11px" }}
                                  onClick={() => {
                                    navigate(`/view-product/${product.id}`);
                                  }}
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                >
                                  <FaEye className="mx-1" />
                                  مشاهدة
                                </motion.button>
                                <motion.button
                                  className="btn btn-sm btn-outline-success"
                                  style={{ fontSize: "11px" }}
                                  onClick={() => {
                                    sessionStorage.setItem(
                                      `product_${product.id}`,
                                      JSON.stringify({
                                        id: product.id,
                                        name_ar: product.name_ar,
                                        name_en: product.name_en,
                                      })
                                    );
                                    navigate(`/edit-product/${product.id}`);
                                  }}
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                >
                                  <FaEdit className="mx-1" />
                                  تعديل
                                </motion.button>

                                <motion.button
                                  className="btn btn-sm btn-outline-danger"
                                  onClick={() => handleDelete(product.id)}
                                  whileHover={{ scale: 1.05 }}
                                  whileTap={{ scale: 0.95 }}
                                  disabled={isLoading}
                                  style={{ fontSize: "11px" }}
                                >
                                  <FaTrash className="mx-1" />
                                  حذف
                                </motion.button>
                              </div>
                            </td>
                          </tr>
                        )) : null}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  {localProducts?.result?.pagination && localProducts.result.pagination.total > 0 && (
                    <div className="d-flex justify-content-center mt-4">
                      {renderPagination()}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal({ isOpen: false, data: null })}
        onConfirm={executeDelete}
        title="تأكيد الحذف"
        message={confirmModal.message || 'هل أنت متأكد من هذا الإجراء؟'}
        confirmText="حذف"
        cancelText="إلغاء"
        confirmButtonColor="#dc3545"
        type="danger"
      />
    </div>
  );
};

export default Products;
